// @flow
import { format } from "lib/getRange";
import { getSize, getWeight } from "views/resources/theme";
import React from "react";
import styled from "styled-components";
import theme from "views/resources/theme";

interface Slice {
	from: String;
	to: String;
}

const DaySlice = ({ label, slices, reserve, selected }) => {
	const hourRanges = slices.map((hr) => {
		const from = hr.from.format("HH:mm");
		const to = hr.to.format("HH:mm");
		const handleClick = () => {
			reserve(hr.from, hr.to, from);
		};
		const isSelected = selected == from;
		return (
			<HourRange.Item
				key={from}
				className={isSelected && "selected"}
				onClick={handleClick}
			>
				{from} - {to}
			</HourRange.Item>
		);
	});
	return (
		<>
			<Group>{label}</Group>
			<HourRange>{hourRanges}</HourRange>
		</>
	);
};

//ex HOur blocks
const HourRange = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
	padding: ${getSize("m")} 0;
	width: 100%;
`;

// ex hour item
HourRange.Item = styled.div`
	background-color: ${(p) => p.selected};
	width: 45%;
	text-align: center;
	background-color: #eae9e9;
	cursor: pointer;
	color: ${(p) => p.color};
	border-radius: ${getSize("xs")};
	margin: 2% 2.5%;
	font-weight: ${getWeight("semibold")};
	height: 32px;
	line-height: 32px;
	box-sizing: border-box;
	&.selected {
		background-color: ${() => theme.colors.secondary_light};
		color: #fff;
	}
`;

const Group = styled.div`
	text-align: center;
	font-weight: ${getWeight("semibold")};
`;

export { DaySlice };
